import { Component } from '@angular/core'
import { SignupFlowService } from '@flowaccount/landing'
import { TranslateService } from '@ngx-translate/core'

@Component({
  selector: 'flowaccount-quotation-document',
  templateUrl: './quotation-document.component.html',
  styleUrls: ['./quotation-document.component.scss'],
})
export class QuotationDocumentComponent {
  public getAltText = this.translate.currentLang === 'th' ? 'ทำใบเสนอราคา' : 'Creating Price Quotations'
  constructor(public translate: TranslateService, private signupFlowService: SignupFlowService) {}

  setCookiePreviousPath(): void {
    this.signupFlowService.setCookie('quotation', true)
  }
}
